import { render, staticRenderFns } from "./organize.vue?vue&type=template&id=f8b21718&scoped=true&"
import script from "./organize.vue?vue&type=script&lang=js&"
export * from "./organize.vue?vue&type=script&lang=js&"
import style0 from "./organize.vue?vue&type=style&index=0&id=f8b21718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b21718",
  null
  
)

export default component.exports